export default "__VITE_ASSET__CC4aSBV1__"